import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  updateTrainingBlockPriority,
  getTrainingBlocks,
} from "../../../../action/masters/trainingActionCreator";
import {
  changePositionOnDrag,
  changeVisibilty,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateTrainingBlockPriority,
  ITrainingBlocks,
} from "../../../../models/master/training";
import { setTrainigBlocks } from "../../../../store/slices/master/trainingBlockSlice";
import LoaderSpinner from "../../../../common-components/loader";
import { ConfigUserTypes } from "../../../../models/dashboard/adminDashboard";

const PriorityTrainingBlock = (props: IUpdateTrainingBlockPriority) => {
  const {
    updateTrainingPriority,
    getTrainingBlocks,
    trainingBlocks,
    configUserRole,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const dispatch = useDispatch();
  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateTrainingPriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    setLoader(true);
    let _items = changeVisibilty(id, _displayOrNot, filteredItems);
    setfilteredItems([..._items]);
    updateTrainingPriority(_items, setAlert);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllTrainingBlocks = async (pageBlockId?: number, 
    noOfItems?: number, 
    configUserType?: number) => {
    setLoader(true)
    try{
      await getTrainingBlocks(pageBlockId, noOfItems, configUserType);
    }
    finally{
      setLoader(false)
    }
  };

  useEffect(() => {
    getAllTrainingBlocks(undefined, undefined, ConfigUserTypes.Staff);
    return () => {
      dispatch(setTrainigBlocks([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    trainingBlocks && setfilteredItems(cloneDeep(trainingBlocks));
  }, [trainingBlocks]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Training Blocks</h2>
        </div>
  
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner/>
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: ITrainingBlocks) => item.displayOrNot)
                  .map((trainingBlock: ITrainingBlocks, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{trainingBlock.priority}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={trainingBlock.displayOrNot}
                            id={trainingBlock.priority + "trainingBlock"}
                            onChange={() => {
                              ChangeVisibleOrNot(
                                trainingBlock.id ?? 0,
                                !trainingBlock.displayOrNot
                              );
                            }}
                          />
                          <label
                            htmlFor={trainingBlock.priority + "trainingBlock"}
                          ></label>
                        </div>
                      </div>
                      <div className="btm">
                        <h2>{trainingBlock.name}</h2>
                        <h6>{trainingBlock.trainingCategory}</h6>
                        <p>{trainingBlock.description}</p>{" "}
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: ITrainingBlocks) => !item.displayOrNot)
                .map((trainingBlock: ITrainingBlocks, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{}</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={trainingBlock.displayOrNot}
                          id={trainingBlock.priority + ""}
                          onChange={() => {
                            
                            ChangeVisibleOrNot(
                              trainingBlock.id ?? 0,
                              !trainingBlock.displayOrNot
                            );
                          }}
                        />
                        <label htmlFor={trainingBlock.priority + ""}></label>
                      </div>
                    </div>
                    <div className="btm">
                      <h2>{trainingBlock.name}</h2>
                      <h6>{trainingBlock.trainingCategory}</h6>
                      <p>{trainingBlock.description}</p>{" "}
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  updateTrainingPriority: (data: any, callBack: Function) =>
    updateTrainingBlockPriority(data, callBack),
  getTrainingBlocks: (pageBlockId?: number, noOfItems?: number, configUserType?: number) =>
    getTrainingBlocks(pageBlockId, noOfItems, configUserType),
};

function mapStateToProps(state: any) {
  return {
    trainingBlocks: state.trainingBlock.trainingBlocks,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriorityTrainingBlock);
